'use strict'
import angular from 'angular';

angular.module('integrations.services', [])
    .service('IntegrationsService', IntegrationsService)

IntegrationsService.$inject = ['IORestangular', 'CoreRestAngular', '$q', 'Upload', 'AppConfig'];

function IntegrationsService(Restangular, CoreRestAngular, $q, Upload, AppConfig) {
    //service wide this variable
    var self = this;
    //service wide restangular calls
    var funcs = {
        'GET': function(route, params) { return Restangular.all(route).customGET(undefined, params) },
        'PUT': function(route, params) { return Restangular.all(route).customPUT(undefined, undefined, params, undefined) },
        'POST': function(route, params) { return Restangular.all(route).post(params) },
        'DELETE': function(route, params) { return Restangular.all(route).customDELETE(undefined, params, undefined) },
        'GETLIST': function(route) { return Restangular.all(route).getList() },
    };

    //promise wrapper to reduce the $q down to one func of code rather than repeated across each method
    function promiseWrap(requestFunc, method, params) {
        var deferred = $q.defer();

        //call the self method with the id and params if any
        self[requestFunc](method, params).then(function(data) {
            if (data && data.plain) {
                deferred.resolve(data.plain());
            } else if (data) {
                deferred.resolve(data);
            } else {
                deferred.reject("Error");
            }

        }, function(error) {
            deferred.reject(error);
        });

        //return the promise
        return deferred.promise;
    }

    //get all integration activity logs
    self.getIntegrationActivityLogs = function(params) {
        return funcs['GET']('integrationActivityLogs/viewIntegrationActivityLogs', params);
    }

    //get detailed integration activity logs
    self.getDetailedIntegrationActivityLogs = function(params) {
        return funcs['GET']('integrationActivityLogs/detailIntegrationActivityLogs', params);
    }

    //get integration activity logs based on search
    self.SearchIntegrationActivityLogs = function(params) {
        return funcs['GET']('integrationActivityLogs/searchIntegrationActivityLogs', params);
    }

    //get detailed integration activity logs based on search
    self.searchDetailIntegrationActivityLogs = function(params) {
        return funcs['GET']('integrationActivityLogs/searchdetailIntegrationActivityLogs', params);
    }

    //get integration activity logs csv
    self.getActivityLogCSV = function(params) {
        return funcs['GET']('integrationActivityLogs/getActivityLogCsv', params);
    }


    //get all integrations
    self.integrations = function() {
        return funcs['GETLIST']('integrations');
    }

    //integration methods
    self.integration = function(method, params) {
        return funcs[method]('integrations/integration', params);
    }

    //ingegration xrefs
    self.integrationXref = function(method, params) {
        return funcs[method]('integrations/integrationXref', params)
    }

    /**
     * @api {get} /integrations/xrefs Get a list of integration xrefs
     * @apiParam {string} integrationName Integration Name (optional)
     * @apiParam {string} integrationTypeName Integration Type Name (optional)
     **/
    self.xrefs = function(method, params) {
        return funcs['GET']('integrations/xrefs', params);
    }

    /**
     * @api {get} /integrations/xrefTypes Get a list of integration xref types
     **/
    self.xrefTypes = function() {
        return funcs['GETLIST']('integrations/xrefTypes');
    }

    /**
     * @api {get} /integrations/[order : product]IntegrationTemplate Get an order integration template
     * @apiParam {number} id Integration Template Id
     **/
    /**
     * @api {post} /integrations/[order : product]IntegrationTemplate Add an order integration template
     * @apiParam {number} clusterId Cluster Id
     * @apiParam {number} fieldId Field Id
     * @apiParam {string} parameter Parameter
     * @apiParam {string} datatype Datatype
     * @apiParam {number} lookupTypeId Lookup Type Id
     * @apiParam {number} required Required
     **/
    /**
     * @api {put} /integrations/[order : product]IntegrationTemplate Update an existing order integration template
     * @apiParam {number} id Order Integration Template Id
     * @apiParam {number} clusterId Cluster Id
     * @apiParam {number} fieldId Field Id
     * @apiParam {string} parameter Parameter
     * @apiParam {string} datatype Datatype
     * @apiParam {number} lookupTypeId Lookup Type Id
     * @apiParam {number} required Required
     **/
    /**
     * @api {delete} /integrations/[order : product]IntegrationTemplate Delete an order integration template
     * @apiParam {number} id Order Integration Template Id
     **/
    self.OrderIntegrationTemplate = function(method, params) {
        return funcs[method]('integrations/orderIntegrationTemplate', params);
    }

    self.ProductIntegrationTemplate = function(method, params) {
        return funcs[method]('integrations/productIntegrationTemplate', params);
    }

    /**
     * @api {get} /integrations/orderIntegrationTemplates Get a list of order integration templates
     * @apiParam {string} integrationName Integration Name
     * @apiParam {string} clusterId External Cluster Id
     **/
    self.OrderIntegrationTemplates = function(method, params) {
        return funcs['GET']('integrations/orderIntegrationTemplates', params);
    }

    /**
     * @api {get} /integrations/productIntegrationTemplates Get a list of order integration templates
     * @apiParam {string} integrationName Integration Name
     * @apiParam {string} productId External Product Id
     **/
    self.ProductIntegrationTemplates = function(method, params) {
        return funcs['GET']('integrations/productIntegrationTemplates', params);
    }

    //cloneProductIntegrationTemplate methods
    self.cloneProductIntegrationTemplate = function(params) {
        return funcs['POST']('integrations/cloneProductIntegrationTemplate', params);
    }

    //cloneOrderIntegrationTemplate methods
    self.cloneOrderIntegrationTemplate = function(params) {
        return funcs['POST']('integrations/cloneOrderIntegrationTemplate', params);
    }

    self.exportIntegration = function(params) {
        return funcs['GET']('integrations/exportIntegration', params);
    }

    self.importIntegration = function(customFile) {
        return Upload.upload({url: AppConfig.IO_API_URL + 'integrations/importIntegration', file: customFile});
    }

    self.configurationForIntegration = function(method, params) {
        return funcs[method]('importerConfiguration/configurationForIntegration', params);
    }
    self.importerConfiguration = function(method, params) {
        return funcs[method]('importerConfiguration/importerConfiguration', params);
    }
    self.refreshSalesforce = function(params) {
        return funcs['POST']('salesforce/importDetailedOpportunities', params);
    }
    self.refreshSalesforceAccounts = function(params) {
        return funcs['POST']('salesforce/importDetailedAccounts', params);
    }
    self.toggleStatus = function(params) {
        return funcs['PUT']('integrations/toggleIntegrationState', params);
    }

    self.ClientIntegrationTemplate = function(method, params) {
        return funcs[method]('clientIntegrationTemplates/clientIntegrationTemplate', params);
    }

    /**
     * @api {get} /clientIntegrationTemplates/clientIntegrationTemplates Get a list of Client integration templates
     * @apiParam {string} integrationName Integration Name
     **/
    self.ClientIntegrationTemplates = function(method, params) {
        return funcs['GET']('clientIntegrationTemplates/clientIntegrationTemplates', params);
    }

    /**
     * @api {get} /integrationActivityLogs/integrationActivityLogs Get a list of Client integration templates
     * @apiParam {string} integrationName Integration Name
     **/
    self.IntegrationActivityLogs = function(params) {
        return funcs['GET']('integrationActivityLogs', params);
    }

    /**
     * @api {get} /connectService/integrationActivityLogs Get a list of Client integration templates
     * @apiParam {string} serviceId Integration Name
     **/
    self.SaveOauth = function(params) {
        return funcs['GET']('oauth/connectservice', params);
    }

    self.getAuthTypes = function(params) {
        return funcs['GET']('webhooks/authTypes', params);
    };

    self.getEventNames = function(params) {
        return funcs['GET']('webhooks/eventNames', params);
    };

    self.getEntityTypes = function(params) {
        return funcs['GET']('webhooks/entityTypes', params);
    };

    self.getWebhookForIntegration = function(params) {
        return funcs['GET']('webhooks/subscriptionForIntegration', params);
    }

    self.saveWebhook = function(params) {
        return funcs['POST']('webhooks/webhookSubscription', params);
    };

    self.updateWebhook = function(params) {
        return funcs['PUT']('webhooks/webhookSubscription', params);
    };

    self.getWebhookSubsEntities = function(param) {
        return funcs['GET']('webhooks/webhookSubscriptionEntities', param);
    }

    self.saveWebhookEntity = function(params) {
        return funcs['POST']('webhooks/webhookSubscriptionEntity', params);
    };

    self.updateWebhookEntity = function(params) {
        return funcs['PUT']('webhooks/webhookSubscriptionEntity', params);
    };

    self.deleteWebhookEntity = function(params) {
        return funcs['DELETE']('webhooks/webhookSubscriptionEntity', params);
    };

    self.webhookUrl = function(id) {
        return CoreRestAngular.all('webhook/newUrl/' + id).customGET(undefined, undefined, undefined, undefined);
    };

    self.getWebhookConsumeExternalFields = function(webhookId, param) {
        return funcs['GET']('webhookConsume/externalFields/' + webhookId, param);
    }

    //service method access object returned by the IntegrationsService
    return {
        getIntegrationActivityLogs: function(method, params) { return promiseWrap('getIntegrationActivityLogs', method, params); },
        getDetailedIntegrationActivityLogs: function(method, params) { return promiseWrap('getDetailedIntegrationActivityLogs', method, params); },
        searchDetailIntegrationActivityLogs: function(method, params) { return promiseWrap('searchDetailIntegrationActivityLogs', method, params); },
        getActivityLogCSV : function(method, params) { return promiseWrap('getActivityLogCSV', method, params); },
        integrations: function() { return promiseWrap('integrations'); },
        integration: function(method, params) { return promiseWrap('integration', method, params); },
        integrationXref: function(method, params) { return promiseWrap('integrationXref', method, params); },
        OrderIntegrationTemplate: function(method, params) { return promiseWrap('OrderIntegrationTemplate', method, params); },
        OrderIntegrationTemplates: function(method, params) { return promiseWrap('OrderIntegrationTemplates', method, params); },
        ProductIntegrationTemplate: function(method, params) { return promiseWrap('ProductIntegrationTemplate', method, params); },
        ProductIntegrationTemplates: function(method, params) { return promiseWrap('ProductIntegrationTemplates', method, params); },
        xrefs: function(method, params) { return promiseWrap('xrefs', method, params); },
        xrefTypes: function() { return promiseWrap('xrefTypes'); },
        cloneProductIntegrationTemplate: function(params) { return promiseWrap('cloneProductIntegrationTemplate', params); },
        cloneOrderIntegrationTemplate: function(params) { return promiseWrap('cloneOrderIntegrationTemplate', params); },
        exportIntegration: function(params) { return promiseWrap('exportIntegration', params); },
        importIntegration: function(customFile) { return promiseWrap('importIntegration', customFile); },
        configurationForIntegration: function(method, params) { return promiseWrap('configurationForIntegration', method, params); },
        importerConfiguration: function(method, params) { return promiseWrap('importerConfiguration', method, params); },
        refreshSalesforce: function(method, params) { return promiseWrap('refreshSalesforce', method, params); },
        refreshSalesforceAccounts: function(method, params) { return promiseWrap('refreshSalesforceAccounts', method, params); },
        toggleStatus: function(method, params) { return promiseWrap('toggleStatus', method, params); },
        ClientIntegrationTemplate: function(method, params) { return promiseWrap('ClientIntegrationTemplate', method, params); },
        ClientIntegrationTemplates: function(method, params) { return promiseWrap('ClientIntegrationTemplates', method, params); },
        IntegrationActivityLogs: function(method, params) { return promiseWrap('IntegrationActivityLogs', method, params); },
        SaveOauth: function(method, params) { return promiseWrap('SaveOauth', method, params); },
        getAuthTypes: function(method, params) { return promiseWrap('getAuthTypes', method, params); },
        getEventNames: function(method, params) { return promiseWrap('getEventNames', method, params); },
        getEntityTypes: function(method, params) { return promiseWrap('getEntityTypes', method, params); },
        saveWebhook: function(method, params) { return promiseWrap('saveWebhook', method, params); },
        updateWebhook: function(method, params) { return promiseWrap('updateWebhook', method, params); },
        getWebhookSubsEntities: function(method, params) { return promiseWrap('getWebhookSubsEntities', method, params); },
        getWebhookForIntegration: function(method, params) { return promiseWrap('getWebhookForIntegration', method, params); },
        saveWebhookEntity: function(method, params) { return promiseWrap('saveWebhookEntity', method, params); },
        updateWebhookEntity: function(method, params) { return promiseWrap('updateWebhookEntity', method, params); },
        deleteWebhookEntity: function(method, params) { return promiseWrap('deleteWebhookEntity', method, params); },
        webhookUrl: function(method, params) { return promiseWrap('webhookUrl', method, params); },
        getWebhookConsumeExternalFields: function(method, params) { return promiseWrap('getWebhookConsumeExternalFields', method, params); },
        SearchIntegrationActivityLogs: function(method, params) { return promiseWrap('SearchIntegrationActivityLogs', method, params); }
    }
}